export default __webpack_public_path__ + "95502c6bdf827c5a0db739265672cd9c9086ada405864cc7be80d72b72334481.svg";